module.exports = __webpack_public_path__ + "static/media/eop-1366x100.970b6288.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/app/images/adverts/eop-1366x100.jpg
// module id = 155
// module chunks = 0